// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import Iconify from '../../../components/iconify/Iconify';
import { title } from 'src/_mock/assets';

// ----------------------------------------------------------------------

export const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
export const iconImage = (name) => (
  <SvgColor src={name} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('vendor'),
  businessTag: icon('business'),
  eventTags: icon('eventTags'),
  ticket_orders: icon('tickets_icon'),
  sponsored_events: icon('sponser'),
  tickets: icon('tickets_icon'),
  campaign: icon('campaign'),
  events: icon('events'),
  venues: icon('venues'),
  EventLabels: icon('eventLabels'),
  EventStrikes: icon('eventstricks'),
  Blogs: icon('blog'),
  Staff: icon('staff'),
  pos: icon('pos'),
  platform: icon('PlatformFee'),
  invoices: icon('invoices'),
  dashboard: icon('dashboard'),
  customers: icon('customer'),
  // analytics: icon('vendor'),
  maintenance: icon('maintainance'),
  discounts: icon('discounts'),
  EventGroup: icon('Eventgroup'),
  EventSlot: icon('EventSlot'),
  ticketsOrder: icon('ticketsorder'),
  artist: icon("artist"),
  TableManagement: icon("TableManagement")
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'Dashboard', path: PATH_DASHBOARD.dashboard.root, icon: ICONS.dashboard },
      { title: 'Partners', path: PATH_DASHBOARD.vendors.root, icon: ICONS.user },
      { title: 'Business Tags', path: PATH_DASHBOARD.businessTags.root, icon: ICONS.businessTag },
      // { title: 'Packages', path: PATH_DASHBOARD.packages.root, icon: ICONS.analytics },
      { title: 'Event Tags', path: PATH_DASHBOARD.eventTags.root, icon: ICONS.eventTags },

      {
        title: 'Events',
        path: PATH_DASHBOARD.events.root,
        icon: ICONS.events,
      },

      {
        title: 'Discount',
        path: PATH_DASHBOARD.discount.root,
        icon: ICONS.discounts,
      },

      {
        title: 'Venues',
        path: PATH_DASHBOARD.Venues.root,
        icon: ICONS.venues,
      },
      {
        title: 'EventLabels',
        path: PATH_DASHBOARD.EventLabels.root,
        icon: ICONS.EventLabels,
      },
      {
        title: 'Packages Strikes/Labels',
        path: PATH_DASHBOARD.EventStrikes.root,
        icon: ICONS.EventStrikes,
      },
      {
        title: 'Artist',
        path: PATH_DASHBOARD.artist.root,
        icon: ICONS.artist,
      },
      {
        title: 'Blogs',
        path: PATH_DASHBOARD.Blogs.root,
        icon: ICONS.Blogs,
      },
      {
        title: 'Ticket Orders',
        path: PATH_DASHBOARD.ticket_orders.root,
        icon: ICONS.ticketsOrder,
      },
      {
        title: 'Sponsored Events',
        path: PATH_DASHBOARD.sponsoredEvents.root,
        icon: ICONS.sponsored_events,
      },
      {
        title: 'Tickets',
        path: PATH_DASHBOARD.cancelTickets.root,
        // icon: <Iconify icon="eva:close-circle-outline" />,
        icon: ICONS.tickets,
      },
      {
        title: 'Event Group',
        path: PATH_DASHBOARD.groupEvents.root,
        // icon: <Iconify icon="eva:close-circle-outline" />,
        icon: ICONS.EventGroup,
      },
      {
        title: 'Event Slot',
        path: PATH_DASHBOARD.event_slot.root,
        // icon: <Iconify icon="eva:close-circle-outline" />,
        icon: ICONS.EventSlot,
      },
      {
        title: 'Entry Reset',
        path: PATH_DASHBOARD.ClearEntryPage.root,
        // icon: <Iconify icon="eva:close-circle-outline" />,
        icon: ICONS.EventSlot,
      },
      {
        title: 'Staff',
        path: PATH_DASHBOARD.staff.root,
        // icon: <Iconify icon="eva:close-circle-outline" />,
        icon: ICONS.Staff,
      },
      {
        title: 'Platform Fee',
        path: PATH_DASHBOARD.platformfee.root,
        // icon: <Iconify icon="eva:close-circle-outline" />,
        icon: ICONS.platform,
      },
      {
        title: 'Invoices',
        icon: ICONS.invoices,
        path: PATH_DASHBOARD.invoices.root, // This should lead to the base path for invoices
        // children: [
        //   {
        //     title: 'Vendor Invoices',
        //     path: PATH_DASHBOARD.invoices.root, // Adjust this to match the correct path for vendor invoices
        //   },
        //   {
        //     title: 'Customer Invoices',
        //     path: PATH_DASHBOARD.invoices.customer, // This should be the path leading to the customer invoices
        //   },
        // ],
      },

      {
        title: 'Customer',
        path: PATH_DASHBOARD.customer.root,
        icon: ICONS.customers,
      },
      {
        title: 'Pos Devices',
        path: PATH_DASHBOARD.pos.root,
        icon: ICONS.pos,
      },

      {
        title: 'Campaign',
        icon: ICONS.campaign,
        // path: `${PATH_DASHBOARD}/campaign`,
        path: PATH_DASHBOARD.campaignPackage.root,
        children: [
          {
            title: 'All Campaigns',
            path: PATH_DASHBOARD.vendorCampaign.root,
          },
          {
            title: 'Credits Package Price',
            path: PATH_DASHBOARD.campaignPackage.root,
          },
          {
            title: 'Add Credits',
            path: PATH_DASHBOARD.campaignCredits.root,
          },
          {
            title: 'Add Templates',
            path: PATH_DASHBOARD.campaignTemplate.root,
          },
          {
            title: 'Add Groups',
            path: PATH_DASHBOARD.campaignGroup.root,
          },
        ],
      },
      {
        title: 'Table Management',
        path: PATH_DASHBOARD.TableManagement.root,
        icon: ICONS.TableManagement
      },
      {
        title: 'Maintenance',
        path: PATH_DASHBOARD.maintenance.root,
        icon: ICONS.maintenance,
      },
    ],
  },
];

export default navConfig;
